<button class="btn btn-actions" 
  [disabled]="disabled"
  [class.fab-btn]='fab && fab === "default"' 
  [class.fab-btn-big]='fab && fab === "big"' 
  [id]='id' type="button" ngbDropdownToggle>
  <svg class="btn-actions-img" version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
      <g transform="translate(-1120 -2049)" fill="currentColor">
        <g transform="translate(976 2001)">
          <g transform="translate(144 48)">
            <path d="m12 10.5c0.82843 0 1.5 0.67157 1.5 1.5s-0.67157 1.5-1.5 1.5-1.5-0.67157-1.5-1.5 0.67157-1.5 1.5-1.5zm-6 0c0.82843 0 1.5 0.67157 1.5 1.5s-0.67157 1.5-1.5 1.5-1.5-0.67157-1.5-1.5 0.67157-1.5 1.5-1.5zm12 0c0.82843 0 1.5 0.67157 1.5 1.5s-0.67157 1.5-1.5 1.5-1.5-0.67157-1.5-1.5 0.67157-1.5 1.5-1.5z"/>
          </g>
        </g>
      </g>
    </g>
  </svg>
</button>
